const initScrollToTop = () => {
    $(window).scroll(function() {
        if ($(this).scrollTop() > 1000) {
            $('#backToTop').fadeIn();
        } else {
            $('#backToTop').fadeOut();
        }
    });

    $('.back-to-top-btn').click(() => {
        window.scrollTo(0, 0);
    });
};

export {
    initScrollToTop
};
